import { Viewer } from '@cesiumgs/cesium-analytics'

/**
 * get current view capture
 * @returns {Blob}
 * @example
 *
 * let blob=view.getBlob();
 * let uri=  URL.createObjectURL(blob);
 * a.href=uri;
 * a.download="download.png";
 * a.click();
 */
Viewer.prototype.getBlob = function (): Blob {
  const image = this.scene.canvas
    .toDataURL('image/png')
    .replace('image/png', 'image/octet-stream')
  const blob = dataURLtoBlob(image)

  function dataURLtoBlob(dataurl: any) {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  }
  return blob
}
